<template>
  <div>
    <div v-if="$auth.ready()">
      <div v-if="$auth.check()">
        <Header />
        <div class="page-container row-fluid">
          <Sidebar />
          <div class="page-content" style="height: 100%">
            <div class="clearfix"></div>
            <div class="content">
              <router-view></router-view>
              <vue-progress-bar></vue-progress-bar>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!$auth.check()">
        <router-view></router-view>
      </div>
    </div>
    <div class="main-loading" v-if="$store.state.loading">
      <img class="fa-spin" src="/assets/img/loading.svg" alt="" />
      <p>Loading Please Wait ...</p>
    </div>
  </div>
</template>

<script>
import router from "@/routes.js";
import Header from "@/layout/Header";
import Sidebar from "@/layout/Sidebar";
import Slide from "bootstrap-slider";

export default {
  router,
  mounted() {
    this.handleSidebar();
  },
  components: {
    Header,
    Sidebar,
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start(500);
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  methods: {
    handleSidebar() {
      jQuery(document).ready(function () {
        setTimeout(function () {
          handleSidebarAndContentHeight();
        }, 1000);

        var handleSidebarAndContentHeight = function () {
          var content = $(".page-content");
          var sidebar = $(".page-sidebar");

          if (!content.attr("data-height")) {
            content.attr("data-height", content.height());
          }

          if (sidebar.height() > content.height()) {
            content.css("min-height", sidebar.height() + 120);
          } else {
            content.css("min-height", content.attr("data-height"));
          }
        };

        /** to hide sub of sub menu when click on other menu */
        $(document).on("click", ".sub-menu-items", function () {
          let ele = $(this).siblings(".open");
          ele.removeClass("open");
          ele.find(".sub-of-sub").slideUp(200);
        });

        $(document).on("click", ".page-sidebar li > a", function (e) {
          if ($(this).next().hasClass("sub-menu") === false) {
            return;
          }
          var offset = $(this).offset();
          /** this is tow scroll sidebar menu to viewpoint */
          $("#main-menu-wrapper").animate({
            scrollTop: offset.top - 155,
            scrollLeft: offset.left,
          });
          var parent = $(this).parent().parent();

          parent
            .children("li.open")
            .children("a")
            .children(".arrow")
            .removeClass("open");
          parent
            .children("li.open")
            .children("a")
            .children(".arrow")
            .removeClass("active");
          parent.children("li.open").children(".sub-menu").slideUp(200);
          parent.children("li").removeClass("open");
          parent.children("li").removeClass("active");

          var sub = $(this).next();
          if (sub.is(":visible")) {
            $(".arrow", $(this)).removeClass("open");
            $(this).parent().removeClass("active");
            sub.slideUp(200, function () {
              handleSidebarAndContentHeight();
            });
          } else {
            $(".arrow", $(this)).addClass("open");
            $(this).parent().addClass("open");
            sub.slideDown(200, function () {
              handleSidebarAndContentHeight();
            });
          }

          e.preventDefault();
        });

        setTimeout(() => {
          var mainMenu = $("#main-menu-wrapper .open .sub-menu").first();
          mainMenu.show();
          $("#main-menu-wrapper .open").find(".arrow").first().addClass("open");

          /** this is tow scroll sidebar menu to viewpoint */
          var offset = $("#main-menu-wrapper .open").offset();
          if (offset && offset.top) {
            $("#main-menu-wrapper").animate({
              scrollTop: offset.top - 155,
              scrollLeft: offset.left,
            });
          }
          var subMenuElement = $(".sub-of-sub .router-link-active")
            .parent()
            .parent()
            .parent();
          subMenuElement.find(".sub-menu").show();
          subMenuElement.find(".arrow").addClass("open");
          subMenuElement.addClass("open");
        }, 1000);
      });
    },
  },
};
</script>
<style lang="scss">
@import "~bootstrap-slider/dist/css/bootstrap-slider.min.css";
@import "~gridforms/gridforms/gridforms.css";
.btn {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}
.main-loading {
  width: 100%;
  z-index: 99999;
  background: #ffffff66;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  position: fixed;
  color: var(--primary-color);
  text-align: center;
  padding: 20%;
  img {
    height: 200px;
  }
  p {
    font-weight: bold;
    font-size: 24px;
    margin-top: 18px;
  }
}
</style>
